<template>
  <div class="w-[81vw] bg-white p-4">
    <div class="flex justify-between items-center mb-6">
      <div class="h-8 bg-gray-500 rounded w-40 animate-pulse"></div>
      <div class="h-6 bg-gray-500 rounded w-16 animate-pulse"></div>
    </div>

    <div class="space-y-4">
      <div v-for="n in 8" :key="n" class="flex items-center space-x-3">
        <div class="w-6 h-6 bg-gray-500 rounded animate-pulse"></div>
        <div class="h-6 bg-gray-500 rounded w-full animate-pulse"></div>
      </div>
    </div>

    <div class="mt-8">
      <div class="h-7 bg-gray-500 rounded w-48 mb-4 animate-pulse"></div>
      <div class="space-y-3">
        <div
            v-for="n in 5"
            :key="n"
            class="h-6 bg-gray-500 rounded w-full animate-pulse"
        ></div>
      </div>
    </div>
  </div>
</template>
